import { Fragment } from "react";
import Select from 'react-select';
import { appDomain } from '../../domain/AppDomain';
import { AppRoutes } from '../../domain/navigation/AppRoutes';
import { IEmployeeGroup } from '../../domain/employeeGroups/IEmployeeGroup';
import { TextInput } from "../basic/TextInput";
import { BaseComponent } from "../core/BaseComponent";
import "./EmployeeGroup.css";
import { ICalendar } from "../../domain/calendars/ICalendar";

interface EmployeeGroupDetailProps {
    id?: string;
}
interface EmployeeGroupDetailState {
    id: string;
    group: IEmployeeGroup;
    isChanged: boolean;
    selectedEmployees: ICalendar[];
    allCalendars: ICalendar[];
}

export class EmployeeGroupDetail extends BaseComponent<EmployeeGroupDetailProps, EmployeeGroupDetailState> {

    constructor(props: EmployeeGroupDetailProps) {
        super(props);
        this.state = { isChanged: true } as any;
    }

    componentDidMount() {
        this.getEmployeeGroup();
    }

    componentDidUpdate() {
        if (this.state.isChanged) {
            this.setStateWhenMounted({ isChanged: false })
            this.getEmployeeGroup();
        }
    }

    handleChangeSelectedEmployees(selectedOption: any) {
        const employeeGroup = this.state.group;
        employeeGroup.links = selectedOption;
        this.setStateWhenMounted({ group: employeeGroup });
    };

    async getEmployeeGroup() {
        const employeeGroup = await appDomain.IEmployeeGroupService.getEmployeeGroup(String(this.props.id)) || { id: null, links: new Array<ICalendar>() } as IEmployeeGroup;

        this.setStateWhenMounted({ group: employeeGroup });

        const allCalendars = await appDomain.IEmployeeService.getAllCalendars();
        this.setStateWhenMounted({ allCalendars });
    }

    static getDerivedStateFromProps(nextProps: EmployeeGroupDetailProps, prevState: any): Partial<EmployeeGroupDetailState> {
        if (prevState.id !== nextProps.id) {
            return { id: nextProps.id, isChanged: true };
        }
        return {} as EmployeeGroupDetailState;
    }

    updateDescription(description: string) {
        if (this.state.group) {
            this.state.group.name = description;
            this.setStateWhenMounted({ group: this.state.group });
        }
    }

    updateSortOrder(sortOrder: number) {
        if (this.state.group) {
            this.state.group.sortOrder = sortOrder;
            this.setStateWhenMounted({ group: this.state.group });
        }
    }

    render() {
        const allCalendars = this.state.allCalendars;

        if (!this.state || !this.state.group || !allCalendars) return <div />;
        const selectedCalendars = this.state.group.links;
        return (
            <Fragment>
                <div className="employee-group-detail">
                    <div className="new-edit-title"> {this.state.group.id ? "Groep bewerken" : "Nieuwe groep"}</div>
                    <TextInput label={this.translate("employeegroup.description")} name="description" value={this.state.group.name} onChange={this.updateDescription.bind(this)} />
                    <TextInput label={this.translate("employeegroup.sortOrder")} name="sortOrder" type="number" value={this.state.group.sortOrder || 0} onChange={this.updateSortOrder.bind(this)} />
                    <div className="employee-selector-wrapper">
                        <label>
                            <span className="field">Gekoppelde personeelsleden</span>
                        </label>
                        <Select
                            isMulti={true}
                            value={selectedCalendars}
                            getOptionValue={(x: ICalendar) => x.id}
                            getOptionLabel={(x: ICalendar) => {
                                const foundEmployee = allCalendars.find(y => x.id.toLowerCase() === y.id.toLowerCase());
                                return foundEmployee ? foundEmployee.name : x.id;
                            }}
                            onChange={this.handleChangeSelectedEmployees.bind(this)}
                            options={allCalendars}
                        />
                    </div>
                </div>

                <div className="footer">
                    <div className="default-button" onClick={() => this.cancel()}>Annuleren </div>
                    <div className="default-button float-right" onClick={() => this.saveAndClose()}>Opslaan </div>
                </div>
            </Fragment>
        );
    }
    async saveAndClose(): Promise<any> {
        if (this.state.group) {
            await appDomain.IEmployeeGroupService.saveEmployeeGroup(this.state.group);

            this.navigateTo(AppRoutes.employeegroups);
        }
    }
    async cancel(): Promise<any> {
        this.navigateTo(AppRoutes.employeegroups);
    }
}
